import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { env } from '../../../app.constant';
import { ApiResponse, DashboardData, DashboardParams } from '../../data/system/dashboard';

@Injectable()
export class DashboardService extends DashboardData {

  constructor(private http: HttpClient) { super(); }

  getBUR(params: DashboardParams): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.dashboard_bur}`;
    return this.http.post<ApiResponse>(host, params);
  }

  getOverAllOperatingBudget(params: DashboardParams): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.dashboard_overall_operating_budget}`;
    return this.http.post<ApiResponse>(host, params);
  }

}
